import { ZoningCodeChangesPopupComponent } from './zoning-code-changes-popup/zoning-code-changes-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { Component } from '@angular/core';
import { ZoningCodeService } from 'src/app/core/services';

@Component({
    standalone: false,
    selector: 'zoning-code-changes-btn',
    templateUrl: './zoning-code-changes-btn.component.html',
    styleUrls: ['./zoning-code-changes-btn.component.sass']

})
export class ZoningCodeChangesBtnComponent {

    constructor(public dialog: MatDialog, public zoningCodeService: ZoningCodeService) { }

    get haveZoningCodeChanges() {
        return !!this.zoningCodeService.syncZoningCodeChanges;
    }

    showChanges(): void {
        this.dialog.open(ZoningCodeChangesPopupComponent, {
            width: '900px',
            data: this.zoningCodeService.syncZoningCodeChanges,
        });
    }

}
